<div id="stream">
    <audio #audioPlayer [src]='audioStreamSource' id="audio1" preload="none"></audio>
</div>